import { Injectable } from '@angular/core';
import { ReinsuranceApiService } from './reinsurance-api.service';
import { getLoggedInUser } from '../shared/security/cookies';

@Injectable({
  providedIn: 'root',
})
export class ReinsurancePostRiskService extends ReinsuranceApiService {
  accountId: number = 0;

  protected getServiceName(): string {
    return '';
  }

  public getInsurerPostedRisks(params: any, successCallBack: any, urlParams?: any): any {
    params.accountId = getLoggedInUser()?.accountId;
    this.service = 'api/account/riskList';
    return this.get(successCallBack, params);
  }

  public getRecords(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/all/riskList';
    return this.get(successCallBack, params);
  }

  public getRiskReport(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/negativeSlipNumberReport';
    return this.get(successCallBack, params);
  }

  ///Open Endpoint for Public Access
  public getPublicRiskReport(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/auth/account/openNegativeSlipNumberReport';
    return this.openGet(successCallBack, params);
  }

  public getAssignedRisks(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/assigned/riskList';
    return this.get(successCallBack, params);
  }

  // Get Sub Risks by Slip Number
  public getSubRiskList(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/riskSubList';
    return this.get(successCallBack, params);
  }

  // /api/account/getRiskBySlipNumber
  public getRiskBySlipNumber(slipNumber: string, successCallBack: any): any {
    this.service = 'api/account/getRiskBySlipNumber?slipNumber=' + slipNumber;
    return this.get(successCallBack);
  }

  public getExternalReInsurerBord(id: number, successCallBack: any): any {
    this.service = 'api/account/externalReInsurerBoard';
    return this.getById(id+"", successCallBack);
  }

  // /api/account/getRiskBySlipNumber
  public getRiskBySlipNumberOpen(slipNumber: string, successCallBack: any): any {
    this.service = 'api/account/getRiskBySlipNumber?slipNumber=' + slipNumber;
    return this.getOpenParams(successCallBack);
  }

  public postRiskFacultative(
    params: any,
    successCallBack?: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ) {
    this.service = 'api/account/postRisk';
    return this.create(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  public postRiskPartial(params: any, successCallBack?: any, urlParams: any = {}, forceMsg?: any, errorCallback?: any) {
    this.service = 'api/account/postRiskPartial';
    return this.create(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  public postRiskFullAdjustment(
    params: any,
    successCallBack?: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ) {
    this.service = 'api/account/postRiskFullAdjustment';
    return this.create(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  public postRiskAutoFacultative(
    params: any,
    successCallBack?: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ) {
    this.service = 'api/account/postAutoRisk';
    return this.create(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  public adjustRiskFacultative(
    params: any,
    successCallBack?: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ) {
    console.log('Params : ' + params);
    if (params.reinsuranceStatus === 'FINALIZED') {
      this.service = 'api/account/postRiskFinalized';
    } else {
      this.service = 'api/account/postRisk';
    }
    return this.create(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  public adjustRiskAutoFacultative(
    params: any,
    successCallBack?: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ) {
    if (params.reinsuranceStatus == 'FINALIZED') {
      this.service = 'api/account/postRiskFinalized';
    } else {
      this.service = 'api/account/postAutoRisk';
    }
    return this.create(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  getReinsuranceAllRisks(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/all/riskList';
    return this.get(successCallBack, params);
  }

  // For Insurer only
  getRiskByFilter(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/all/riskListByFilter';
    return this.get(successCallBack, params);
  }

  // For Both
  getzReinsurerRiskByFilter(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/assigned/riskListStatus';
    return this.get(successCallBack, params);
  }

  getOfferedRisks(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/assigned/riskListOffered';
    return this.get(successCallBack, params);
  }

  getReinsurerAssignedRisks(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/assigned/riskList';
    params.accountId = getLoggedInUser().accountId;
    return this.get(successCallBack, params);
  }

  getPostedRiskById(item: any, successCallBack: any) {
    this.service = 'api/account/getRisk/';
    return this.getById(item.premiumRiskId, successCallBack);
  }

  getPostedRiskBySourceId(source: any, successCallBack: any) {
    this.service = 'api/account/getRisk/';
    return this.getById(source.id, successCallBack);
  }

  public postRiskUploadDocuments(
    params: any,
    successCallBack?: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ) {
    this.service = 'api/account/riskAttachmentUpload';
    return this.createFromFormData(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  getPostedRiskAttachmentsById(item: any, successCallBack: any) {
    this.service = 'api/account/riskAttachmentList';
    return this.getById(item.id, successCallBack);
  }

  getPostedRiskAttachmentsBySlipNumber(params: any, successCallBack: any) {
    this.service = 'api/account/riskAttachments/getBySlipNumber';
    return this.get(successCallBack, params);
  }

  cancelRisk(packet: any, successCallBack?: any, urlParams: any = {}, forceMsg?: any, errorCallback?: any) {
    this.service = 'api/account/postRiskCancellation';
    return this.create(packet, successCallBack, urlParams, forceMsg, errorCallback);
  }

  postQuotationToRisk(params: any, successCallBack?: any, urlParams: any = {}, forceMsg?: any, errorCallback?: any) {
    this.service = 'api/account/postRiskQuotation';

    let packet: any = {};
    packet.id = params.id;
    packet.reinsuranceRiskIsQuotation = params.reinsuranceRiskIsQuotation;

    return this.create(packet, successCallBack, urlParams, forceMsg, errorCallback);
  }

  // /api/claims/premiumTransactionListByPremiumId
  getPremiumTransactionListByPremiumId(params: any, successCallBack: any) {
    this.service = 'api/claims/premiumTransactionListByPremiumId';
    return this.get(successCallBack, params);
  }

  requestPremiumPaymentEFT(
    params: any,
    successCallBack: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ) {
    this.service = 'api/claims/payEFT';
    return this.create(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  requestBrokerPremiumPaymentEFT(
    params: any,
    successCallBack: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ) {
    this.service = 'api/claims/payBrokerEFT';
    return this.create(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  postRiskPopAttachmentUpload(
    params: any,
    successCallBack?: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ) {
    this.service = 'api/claims/popAttachmentUpload';
    return this.createFromFormData(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  postBrokerRiskPopAttachmentUpload(
    params: any,
    successCallBack?: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ) {
    this.service = 'api/claims/brokerPoPAttachmentUpload';
    return this.createFromFormData(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  approveQuotationSubRisk(params: any, successCallBack: any, urlParams: any = {}, forceMsg?: any, errorCallback?: any) {
    this.service = 'api/account/postSublistApproval';
    return this.create(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  externalizeRisk(params: any, successCallBack: any, urlParams: any = {}, forceMsg?: any, errorCallback?: any) {
    this.service = 'api/account/postExternalization';
    return this.create(params, successCallBack, urlParams, forceMsg, errorCallback);
  }

  getExternalizationRequestList(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/externalizationRequestList';
    return this.get(successCallBack, params);
  }

  getReinsurerExternalizationRequestList(params: any, successCallBack: any, urlParams?: any): any {
    this.service = 'api/account/reinsurerExternalizationRequestList';
    return this.get(successCallBack, params);
  }
}
